import * as React from 'react';
import { useSelector } from 'react-redux';
import CustomLink from '../_common/custom-link/custom-link';
import HtmlContent from '../_common/html-content';
import { get } from '../../helpers';
import './search-empty-results.style.scss';

function SearchEmptyResults(props: SearchEmptyResultProps) {
    const { noResultsFound, message, isModified, otherPages, isLLMSearch } = props;
    const enabledBlueprintFlag = useSelector((state: RootStoreState) => get(state, 'shared.flags.enabledBlueprintFlag', false));

    const htmlString = message || '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    const listItems = tempDiv.querySelectorAll('li');
    if (listItems.length > 0) {
        const ulElement = document.createElement('ul');
        listItems.forEach(li => ulElement.appendChild(li));
        tempDiv.insertBefore(ulElement, tempDiv.firstChild);
    }
    const modifiedHtmlString = tempDiv.innerHTML;
    return (
        <section className={otherPages && !isLLMSearch ? 'search-empty-results-otherPages page-section' : 'search-empty-results page-section'}>
            <div className={otherPages && !isLLMSearch ? 'page-section__inner' : ''}>
                <h2 className="h3" role="alert">{noResultsFound}</h2>
                <HtmlContent html={modifiedHtmlString} />
                {isModified &&
                <div className="search-empty-results__links">
                    <div>Try browsing for</div>
                    <CustomLink
                        text="Datasets"
                        url="/datasets"
                        linkTheme="alternative"
                    />

                    <CustomLink
                        text="Solutions"
                        url="/solutions"
                        linkTheme="alternative"
                    />
                    {enabledBlueprintFlag && (
                        <CustomLink
                            text="Blueprints"
                            url="/blueprints"
                            linkTheme="alternative"
                        />
                    )}
                    {/* <CustomLink
                        text="Research"
                        url="https://www.spglobal.com/marketintelligence/en/news-insights/research/index"
                        linkTheme="alternative"
                    />
                    <CustomLink
                        text="Queries"
                        url="/support/query-library"
                        linkTheme="alternative"
                    /> */}
                </div>}
            </div>
        </section>
    );
}

export default React.memo(SearchEmptyResults);
